<template>
  <v-dialog
    v-model="isDialog"
    max-width="600"
    light
  >
    <v-card v-if="isDialog">
      <!--            <div class="safeScroll">-->
      <div class="absX" @click.passive="closeDialog(true)">
        <v-icon x-large class="myGray">mdi-window-close</v-icon>
      </div>
      <div class="spacer-25"></div>
      <v-card-title class="headline text-center d-block" v-html="question"></v-card-title>

      <v-card-text v-if="text">
        <div v-html="text"></div>
      </v-card-text>

      <div class="spacer-15"></div>
      <v-card-actions class="text-center justify-center flex-wrap">
        <v-btn class="okBtn btn-df text-none mb-4" rounded
               @click.native.passive.stop="doYes">{{ yesLabel }}
        </v-btn>
        <v-btn class="text-none mb-4" v-if="noLabel.length>0" rounded
               :class="{'okBtn':!biggerYesButton, 'btn-df':!biggerYesButton, 'btn-mini':biggerYesButton}"
               @click.native.passive.stop="doNo">
          {{ noLabel }}
        </v-btn>
      </v-card-actions>
<!--      <div class="pb-3"></div>-->
      <!--            </div>-->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    question: String,
    biggerYesButton: {
      type: Boolean,
      default: false,
    },
    yesLabel: {
      type: String,
      default: 'Ja'
    },
    noLabel: {
      type: String,
      default: 'Nein'
    },
    text: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isDialog: false
    }
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      console.log('update dialog=' + !!newValue);
      if (newValue) {
        //init
      }
    },
    isDialog(newValue) {
      console.log('update isDialog=' + !!newValue);
      if (!newValue) {
        this.$emit('silentclose');
        // this.ready = false;
        // this.$emit('close');
      }
    }
  },

  methods: {
    closeDialog(explizitClose) {
      this.isDialog = false;
      console.log('question isDialog = false; explizitClose=' + !!explizitClose);
      if (explizitClose) {
        this.$emit('close');//no
      } else {
        this.$emit('silentclose');
      }
    },
    doYes() {
      this.closeDialog();
      this.$emit('yes');
    },
    doNo() {
      this.closeDialog();
      this.$emit('no');
    }
  }
}
</script>

<style lang="scss" scoped>
/*@import '../styles/vuetify-dark';*/
</style>
